module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"hidden-xs hidden-sm\"> <header></header> <div class=\"panel filter-panel\"> <div id=\"cash_flow_daterange_pickers\" class=\"filter\"></div> <div id=\"utc_offset_selector\" class=\"filter\"></div> <div id=\"request_cash_flow_report\" class=\"filter\"></div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/cash_flow/template.ejs
// module id = 825
// module chunks = 1